document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".loginSpotlightSlider", {
    slidesPerView: 3,
    spaceBetween: 5, // Gap ko 20 se kam kar ke 10 kar diya hai

    loop: true,
    grabCursor: true,
    speed: 700,
    watchOverflow: true,
    mousewheel: false,
    freeMode: false,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 5 // Yahan bhi gap kam kar diya hai
      }
    }
  });
});